import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { HospitalService } from "../../../../services/hospital.service";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { Hospitals } from "../../../../interfaces/Hospitals";
import { FileUploadDialogComponent } from "../../../../upload/file-upload-dialog/file-upload-dialog.component";
import { UserData } from "../../../../auth.service";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AngularFireDatabase } from "@angular/fire/compat/database";
import { FileUpload } from "../../../../upload/image-upload/file-upload";
import { needConfirmation } from "../../../../confirm-dialog/confirm-dialog.decorator";
import { UploadFile } from "../../../../interfaces/uploadFile";
import firebase from "firebase/compat";
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from "@angular/fire/compat/storage";
import { finalize, map } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";
import { DocumentDateDialogComponent } from "./document-date-dialog/document-date-dialog.component";
import { FileUploadService } from "../../../../upload/image-upload/upload.service";
@Component({
  selector: 'app-display-hospital',
  templateUrl: './display-hospital.component.html',
  styleUrls: ['./display-hospital.component.scss']
})
export class DisplayHospitalComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject<void>();
  hospitals: Hospitals[] = [];
  datasource: Hospitals[] = []
  removedDrDetails: any[] = []
  userData: UserData
  externalUser: boolean = false
  hospital$: Observable<Hospitals | null>
  mHospitalPath = 'Hospitals'
  selectedFile: File | null = null;
  uploadProgress$: Observable<any> | undefined;
  selectedTitle: string = '';
  mHospitalDocumentsType$: Observable<string[]>
  showUpload = false
  mHopitalDoucmentsObservable$: Observable<FileUpload[]> | undefined;
  deletedDoctorColumns: string[] = ['doctorsName', 'designation', 'phoneNo', 'email', 'reason'];
  notesArray: any[] = [];
  assignedCenters: any[] = [];
  constructor(private mService: HospitalService,
    private readonly mDialog: MatDialog,
    private readonly mStorage: AngularFireStorage,
    private readonly mSnackBar: MatSnackBar,
    private readonly mDatabase: AngularFireDatabase,
    private fileUploadService: FileUploadService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.notesArray = Object.values(this.data.notes || {});
    this.userData = JSON.parse(localStorage.getItem('userData')!) as UserData
    this.externalUser = this.userData.department === 'External User'
    this.mHospitalDocumentsType$ = this.mDatabase.list<string>('types/HospitalDocuments').valueChanges()
    this.hospital$ = this.mService.getHospitalById(data.id)
    console.log("data", data)
    this.assignedCenters = Object.values(data.isAssociateCenter || {});
    this.mHospitalPath = `Hospitals/${data.id}/documents`
    this.mHopitalDoucmentsObservable$ = this.mDatabase
      .list<FileUpload>(this.mHospitalPath)
      .snapshotChanges()
      .pipe(
        map(actions => {
          return actions
            .map(action => {
              const payload = action.payload.val();
              if (action.payload.exists()) {
                return {
                  key: action.payload.key,
                  fileName: (payload as any).fileName,
                  imageUrl: (payload as any).imageUrl,
                  renewalDate: (payload as any).renewalDate ?? null,
                  dueDate: (payload as any).dueDate ?? null
                } as FileUpload;
              } else {
                return null;
              }
            })
            .filter(item => item !== null) as FileUpload[];
        })
      );

  }
  documentMeta: { renewalDate: any | null; dueDate: any | null } | null = null;
  openDialog() {
    const dialogRef = this.mDialog.open(DocumentDateDialogComponent, {
      width: '400px',
      data: { selectedTitle: this.selectedTitle }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.documentMeta = {
          renewalDate: result.renewalDate,
          dueDate: result.dueDate
        };
        console.log('Document Meta:', this.documentMeta);
      }
    });
  }

  addNewDocumentType() {
    const newType = prompt('Enter new document type (e.g., Need Assessment):');
    if (newType && newType.trim() !== '') {
      this.mDatabase.list('types/HospitalDocuments').push(newType.trim()).then(() => {
        this.mSnackBar.open('Document type added successfully', '', { duration: 2000 });
        this.selectedTitle = newType.trim();
      }).catch(err => {
        console.error('Error adding document type', err);
        this.mSnackBar.open('Error adding document type', '', { duration: 3000 });
      });
    }
  }

  ngOnInit(): void {
    this.mService.getAllHospitals().pipe(takeUntil(this._destroyed$)).subscribe((hospitals: any[]) => {
      this.hospitals = [];
      hospitals.forEach(hospital => {
        if (hospital?.removedDrDetails) {
          const removedArray = Object.values(hospital?.removedDrDetails);
          this.removedDrDetails.push(...removedArray);
        }

        this.hospitals.push(hospital);
      });

      this.hospitals.reverse();
      this.datasource = this.hospitals;
    });
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }


  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.selectedFile = file;
      console.log('File selected:', file);
    }
  }

  async uploadFile(): Promise<void> {
    if (!this.selectedFile || !this.selectedTitle) {
      this.mSnackBar.open('Please select both title and file.', '', { duration: 3000 });
      return;
    }

    const file = this.selectedFile;
    const filePath = `hospitalDocuments/${file.name}`;
    const storageRef = this.mStorage.ref(filePath);
    const uploadTask = this.mStorage.upload(filePath, file);

    this.uploadProgress$ = uploadTask.percentageChanges();

    try {
      // Wait for the upload to complete
      await uploadTask.snapshotChanges().toPromise();

      // Get download URL
      const downloadURL = await storageRef.getDownloadURL().toPromise();

      // Prepare data to push
      const fileData = {
        fileName: this.selectedTitle,
        imageUrl: downloadURL,
        renewalDate: this.documentMeta?.renewalDate.toString() ?? '',
        dueDate: this.documentMeta?.dueDate.toString() ?? ''  //string format
        // dueDate: this.documentMeta?.dueDate.getTime() ?? 0 //number format
      };
      console.log(fileData)

      // Save metadata to Realtime Database
      await this.mDatabase.list(this.mHospitalPath).push(fileData);

      this.mSnackBar.open('File uploaded successfully', '', { duration: 2000 });

      // Reset form fields
      this.selectedFile = null;
      this.selectedTitle = '';
      this.documentMeta = { renewalDate: null, dueDate: null };

    } catch (error) {
      console.error('🚨 Upload or DB error:', error);
      this.mSnackBar.open('Error uploading file or saving data', '', { duration: 3000 });
    }
  }


  protected readonly Array = Array;
  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  openLink(fileUrl: string) {
    window.open(fileUrl)
  }

  @needConfirmation()
  deleteDocument2(file: FileUpload) {
    //url is https://firebasestorage.googleapis.com/v0/b/acceife-fbdb5.appspot.com/o/hospitalDocuments%2Fad2.jpg?alt=media&token=b0ec1a7a-e000-451b-a1b1-ae1b1e70ddec
    const iRef = this.mStorage.storage.ref(file.imageUrl)
    iRef.delete().then(() => {
      this.mDatabase.object(`${this.mHospitalPath}/${file.key}`).remove()
        .then(res => {
          this.mSnackBar.open('File Deleted Successfully', '', { duration: 2000 });
        }).catch(databaseError => {
          console.error('Database update error:', databaseError);
          this.mSnackBar.open('Error updating database', '', { duration: 3000 });
        });
    }).catch((storageError: any) => {
      console.error('Storage delete error:', storageError);
      this.mSnackBar.open('Error deleting file', '', { duration: 3000 });
    });

  }

  @needConfirmation()
  deleteDocument(file: FileUpload) {
    //url is https://firebasestorage.googleapis.com/v0/b/acceife-fbdb5.appspot.com/o/hospitalDocuments%2Fad2.jpg?alt=media&token=b0ec1a7a-e000-451b-a1b1-ae1b1e70ddec
    // alert(`${this.mHospitalPath}/${file.key}`)
    this.mDatabase.object(`${this.mHospitalPath}/${file.key}`).remove().then(res => {
      this.mSnackBar.open('File Deleted Successfully', '', { duration: 2000 });

    }).catch(databaseError => {
      console.error('Database update error:', databaseError);
      this.mSnackBar.open('Error updating database', '', { duration: 3000 });
    });



  }


}
